// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// // import FacebookLogin from "react-facebook-login";
// import Logo from '../img/logo.png'; // นำเข้าภาพพื้นหลัง
// import lineLogo from '../img/line.png'; // นำเข้าภาพพื้นหลัง
// import bcrypt from 'bcryptjs';
// import Navbar from "../navbarv2/navbar";
// import Footer from "../navbarv2/footer";
// import { GoogleLogin } from 'react-google-login';
// import { gapi } from 'gapi-script';
// import liff from '@line/liff';
// import { LIFF_ID, API_ENDPOINT, API_ENDPOINT_USER } from '../auth/config';
// import Swal from 'sweetalert2';
// function LoginForm() {
//   const [isLoggedIn, setIsLoggedIn] = useState(false); // เพิ่มสถานะ isLoggedIn เพื่อเก็บสถานะการล็อกอินของผู้ใช้
//   const navigate = useNavigate();
//   const [inputs, setInputs] = useState({});
//   const [errorMessage, setErrorMessage] = useState("");
//   const [showErrorMessage, setShowErrorMessage] = useState(false);



//   const date = new Date();
//   const time = date.toISOString().replace(/[-:T.]/g, '').slice(0, 14); // 'YmdH' format
//   const timeWithKey = time + '@pay';
//   const saltRounds = 10;
//   const clientId = "381801295139-qnj77qb40mfo3fi73q99fc3tq59rq6qg.apps.googleusercontent.com";


//   // line login ///
//   useEffect(() => {
//     liff.init({ liffId: `${LIFF_ID}` })
//   }, [])

//   const handleLogin = (event) => {
//     try {
//       liff.login();
//     } catch (err) {
//       console.log(err);
//     }
//   }
//   // line login ///



//   // google login ///
//   useEffect(() => {
//     const initClient = () => {
//       gapi.client.init({
//         clientId: clientId,
//         scope: ''
//       })
//     }
//     gapi.load("client:auth2", initClient)
//   }, [])

//   const onSuccess = (res) => {


//     Slogin(res.profileObj.email, "google", res.profileObj.googleId.slice(0, 10), res.profileObj.name, res.profileObj.googleId);
//     //  console.log(res);
//     // bcrypt.hash(timeWithKey, saltRounds, (err, hash) => {
//     //   if (err) {
//     //     console.error('Error hashing password:', err);
//     //     return;
//     //   }
//     //   const shortGoogleId = res.profileObj.googleId.slice(0, 10); // ตัดให้เหลือ 10 ตัวอักษ
//     //   genApiKey(shortGoogleId, hash)
//     //   setHashedPassword(hash);
//     //   console.log(hash);
//     //   console.log(timeWithKey);
//     // });

//     // localStorage.setItem('email', res.tokenObj.idpId)
//     // localStorage.setItem('userid', res.profileObj.googleId.slice(0, 10))
//     // localStorage.setItem('name', res.profileObj.name)
//     // localStorage.setItem('token', res.profileObj.googleId)
//     // navigate('/Home');

//   }
//   const onFailure = (res) => {
//     console.log('failed', res);
//   }
//   // google login ///

//   // facbook login ///
//   // const componentClicked = (data) => {
//   //   // console.log("data", data);
//   // };

//   // const responseFacebook = (response) => {
//   //   // console.log(response);
//   //   // setAccessToken(response.accessToken);
//   //   // setAccessname(response.name);
//   //   // setAccessid(response.id);
//   //   bcrypt.hash(timeWithKey, saltRounds, (err, hash) => {
//   //     if (err) {
//   //       console.error('Error hashing password:', err);
//   //       return;
//   //     }
//   //     genApiKey(response.id, hash)
//   //     // setHashedPassword(hash);
//   //     // console.log(hash);
//   //     // console.log(timeWithKey);
//   //   });
//   //   localStorage.setItem('email', response.graphDomain)
//   //   localStorage.setItem('userid', response.id)
//   //   localStorage.setItem('name', response.name)
//   //   localStorage.setItem('token', response.accessToken)
//   //   navigate('/Home');
//   // };

//   // facbook login ///




//   useEffect(() => {
//     const isLoggedIn = localStorage.getItem('token');
//     if (isLoggedIn) {
//       setIsLoggedIn(true);
//       navigate('/Home'); // นำทางไปยังหน้าหลักโดยตรงหากผู้ใช้ล็อกอินอยู่แล้ว
//     }
//   }, [navigate]);

//   const handleChange = (event) => {
//     const name = event.target.name;
//     const value = event.target.value;
//     setInputs(values => ({ ...values, [name]: value }))
//   }

//   // const handleSubmit = (event) => {
//   //   event.preventDefault();
//   //   const formdata = new FormData();
//   //   formdata.append("email", inputs.email);
//   //   formdata.append("password", inputs.password);

//   //   const requestOptions = {
//   //     method: "POST",
//   //     body: formdata,
//   //     redirect: "follow"
//   //   };

//   //   fetch(`${API_ENDPOINT_USER}/e-member/public/api/login`, requestOptions)
//   //     .then((response) => response.json())
//   //     .then((result) => {
//   //       if (result.staus === true) {

//   //            // console.log(result);
//   //            setErrorMessage("Login successful");
//   //            setShowErrorMessage(true);
//   //            setIsLoggedIn(true); // ตั้งค่า isLoggedIn เป็น true เมื่อล็อกอินสำเร็จ
//   //            bcrypt.hash(timeWithKey, saltRounds, (err, hash) => {
//   //              if (err) {
//   //                console.error('Error hashing password:', err);
//   //                return;
//   //              }
//   //              genApiKey(result.user_id, hash)

//   //            });

//   //            localStorage.setItem('email', result.email)
//   //            localStorage.setItem('userid', result.user_id)
//   //            localStorage.setItem('name', result.name)
//   //            localStorage.setItem('token', result.access_token)
//   //            navigate('/Home');

//   //       } else {

//   //       }
//   //     })
//   //     .catch((error) => console.error(error));

//   // }

//   const handleSubmit = (event) => {
//     event.preventDefault();
  
//     const formdata = new FormData();
//     formdata.append("email", inputs.email);
//     formdata.append("password", inputs.password);
  
//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow",
//     };
  
//     fetch(`${API_ENDPOINT_USER}/e-member/public/api/login`, requestOptions)
//       .then((response) => response.json())
//       .then((result) => {
//         if (result.status === true) {
//           // แสดง SweetAlert สำหรับความสำเร็จ
//           Swal.fire({
//             title: 'Login Successful',
//             text: `Welcome, ${result.name}`,
//             icon: 'success',
//             confirmButtonText: 'Continue',
//           }).then(() => {
//             bcrypt.hash(timeWithKey, saltRounds, (err, hash) => {
//               if (err) {
//                 console.error('Error hashing password:', err);
//                 return;
//               }
//               genApiKey(result.user_id, hash)
//               // console.log(hash);
//               // console.log(timeWithKey);
//             });
//             // ดำเนินการหลังจากผู้ใช้กดปุ่ม
//             localStorage.setItem("email", result.email);
//             localStorage.setItem("userid", result.user_id);
//             localStorage.setItem("name", result.name);
//             localStorage.setItem("token", result.access_token);
//             navigate('/Home');
//           });
//         } else {
//           // แสดง SweetAlert สำหรับข้อผิดพลาด
//           Swal.fire({
//             title: 'Login Failed',
//             text: 'Please check your credentials and try again.',
//             icon: 'error',
//             confirmButtonText: 'Retry',
//           });
//         }
//       })
//       .catch((error) => {
//         // แสดง SweetAlert สำหรับข้อผิดพลาดระบบ
//         console.error("Error during login process:", error);
//         Swal.fire({
//           title: 'Error',
//           text: 'Something went wrong. Please try again later.',
//           icon: 'error',
//           confirmButtonText: 'OK',
//         });
//       });
//   };


//   const Slogin = (email, provider, provider_id, name, token) => {
//     const formdata = new FormData();
//     formdata.append("email", email);
//     formdata.append("provider", provider);
//     formdata.append("provider_id", provider_id);
//     formdata.append("name", name);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch(`${API_ENDPOINT_USER}/e-member/public/api/slogin`, requestOptions)
//       .then((response) => response.json())
//       .then((result) => {
//         if (result.status === "true") {
//           bcrypt.hash(timeWithKey, saltRounds, (err, hash) => {
//             if (err) {
//               console.error('Error hashing password:', err);
//               return;
//             }
//             genApiKey(result.msg.id, hash)
//             // console.log(hash);
//             // console.log(timeWithKey);
//           });
//           localStorage.setItem('email', result.msg.email);
//           localStorage.setItem('userid', result.msg.id);
//           localStorage.setItem('name', result.msg.name);
//           localStorage.setItem('token', token);

//           // window.location = "/Home";
//           navigate('/Home');
//         }
//       })
//       .catch((error) => console.error(error));

//   }

//   const genApiKey = (iduset, auth) => {


//     // สร้าง URL พร้อม query parameters
//     const url = new URL(`${API_ENDPOINT}/api/v1/zoo/public/e-member/genApiKey`);
//     url.searchParams.append("model", "web");
//     url.searchParams.append("member_id", iduset);
//     url.searchParams.append("time", time);
//     url.searchParams.append("auth", auth);

//     const requestOptions = {
//       method: "GET",
//       redirect: "follow"
//     };

//     fetch(url, requestOptions)
//       .then(response => {
//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }
//         return response.json(); // เปลี่ยนเป็น response.text() ถ้าคุณต้องการรับข้อมูลเป็นข้อความ
//       })
//       .then(result => {
//         // console.log(result[0]); // แสดงผลลัพธ์ใน console
//         // console.log(result[1]); // แสดงผลลัพธ์ใน console
//         localStorage.setItem('apikey', result[0].replace(/^"|"$/g, '')); // เก็บข้อมูลใน localStorage
//         localStorage.setItem('credit', result[1].replace(/^"|"$/g, '')); // เก็บข้อมูลใน localStorage
//       })
//       .catch(error => {
//         console.error('Fetch error:', error); // จัดการข้อผิดพลาด
//       });
//   }





//   return (

//     <>

//       <Navbar></Navbar>
//       <section className="background-radial-gradient overflow-hidden full-height">
//         <div className="container px-4 py-5 px-md-5 text-center text-lg-start my-5">
//           <div className="row gx-lg-5 align-items-center mb-5">
//             <div className="col-lg-6 mb-5 mb-lg-0" style={{ zIndex: 10 }}>
//               <img src={Logo} alt="Logo" className="mb-4" style={{ maxWidth: '150px' }} />
//               <h1 className="my-2 display-5 fw-bold ls-tight" style={{ color: 'hsl(218, 81%, 95%)' }}>
//                 Welcome Sing in<br />
//                 <span style={{ color: 'hsl(218, 81%, 75%)' }}>To Zoo e-Ticket</span>
//               </h1>
//               <p className="mb-4 opacity-70" style={{ color: 'hsl(218, 81%, 85%)' }}>
//                 องค์การสวนสัตว์แห่งประเทศไทย ในพระบรมราชูปถัมภ์
//                 The Zoological Park Organization under The Royal Patronage of H.M. The King
//                 เลขที่ 327 ถนนสุโชทัย แขวงดุสิต เขตดุสิต กรุงเทพมหานคร 10300
//               </p>
//             </div>

//             <div className="col-lg-6 mb-5 mb-lg-0 position-relative">
//               <div id="radius-shape-1" className="position-absolute rounded-circle shadow-5-strong"></div>
//               <div id="radius-shape-2" className="position-absolute shadow-5-strong"></div>

//               <div className="card bg-glass">
//                 <div className="card-body px-4 py-5 px-md-5">
//                   {/* {showErrorMessage && (
//                     <div className='container'>  <div className={`alert ${errorMessage === "Invalid Credentials" ? "alert-danger" : "alert-success"}`} role="alert">
//                       {errorMessage}
//                     </div></div>

//                   )} */}
//                   <form onSubmit={handleSubmit}>
//                     {/* <div className="row">
//                   <div className="col-md-6 mb-4">
//                     <div className="form-outline">
//                       <input type="text" id="form3Example1" className="form-control" />
//                       <label className="form-label" htmlFor="form3Example1">First name</label>
//                     </div>
//                   </div>
//                   <div className="col-md-6 mb-4">
//                     <div className="form-outline">
//                       <input type="text" id="form3Example2" className="form-control" />
//                       <label className="form-label" htmlFor="form3Example2">Last name</label>
//                     </div>
//                   </div>
//                 </div> */}

//                     <div className="form-outline mb-4">
//                       <input type="email" id="emain" name='email' className="form-control" onChange={handleChange} />
//                       <label className="form-label" htmlFor="form3Example3">Email address</label>
//                     </div>

//                     <div className="form-outline mb-4">
//                       <input type="password" id="password" name='password' className="form-control" onChange={handleChange} />
//                       <label className="form-label" htmlFor="form3Example4">Password</label>
//                     </div>


//                     <button type="submit" className="btn btn-primary btn-block mb-4">
//                       เข้าสู่ระบบ
//                     </button>

//                     <div className="text-center py-3">
//                       {/* <FacebookLogin
//                         appId="936346908304074"
//                         autoLoad={false}
//                         fields="name,email,picture"
//                         callback={responseFacebook}
//                         onClick={componentClicked}
//                         icon={<i className="fab fa-facebook-f"></i>}
//                         cssClass="btn btn-link btn-primary btn-floating mx-1 btn-facebook-blue"
//                       /> */}
//                       <GoogleLogin
//                         clientId={clientId} // ใส่ Client ID ของคุณที่นี่
//                         buttonText="Login with Google"
//                         onSuccess={onSuccess}
//                         onFailure={onFailure}
//                         cookiePolicy={'single_host_origin'}
//                         isSignedIn={true}
//                       />
//                       <button
//                         onClick={handleLogin}
//                         type="button"
//                         className="btn btn-link btn-success btn-floating mx-1 btn-line-success mt-2"
//                       >
//                         <img src={lineLogo} alt="LINE Logo" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
//                         Login with LINE
//                       </button>
//                       {/* <button type="button" className="btn btn-link btn-floating mx-1">
//                     <i className="fab fa-facebook-f"></i>
//                   </button>

//                   <button type="button" className="btn btn-link btn-floating mx-1">
//                     <i className="fab fa-google"></i>
//                   </button>

//                   <button type="button" className="btn btn-link btn-floating mx-1">
//                     <i className="fab fa-twitter"></i>
//                   </button>

//                   <button type="button" className="btn btn-link btn-floating mx-1">
//                     <i className="fab fa-github"></i>
//                   </button> */}
//                     </div>
//                     <div className='text-center'>
//                       <Link to="/regis" style={{ fontSize: 25, fontWeight: '275', border: 'none', color: '#17612F' }} >สมัครสมาชิก!!</Link>
//                     </div>

//                   </form>

//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer></Footer>
//     </>
//   );
// }

// export default LoginForm;



import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../img/logo.png';
import lineLogo from '../img/line.png';
import bcrypt from 'bcryptjs';
import Navbar from "../navbarv2/navbar";
import Footer from "../navbarv2/footer";
import { GoogleLogin } from 'react-google-login';
import { gapi } from 'gapi-script';
import liff from '@line/liff';
import { LIFF_ID, API_ENDPOINT, API_ENDPOINT_USER } from '../auth/config';
import Swal from 'sweetalert2';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Outfit:wght@300;400;500;600&display=swap');

  .zoo-login-page {
    min-height: 100vh;
    background: #0a1628;
    position: relative;
    overflow: hidden;
  }

  .zoo-login-page::before {
    content: '';
    position: absolute;
    width: 700px;
    height: 700px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(34, 197, 94, 0.12) 0%, transparent 70%);
    top: -200px;
    right: -200px;
    pointer-events: none;
  }

  .zoo-login-page::after {
    content: '';
    position: absolute;
    width: 500px;
    height: 500px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(16, 185, 129, 0.08) 0%, transparent 70%);
    bottom: -150px;
    left: -100px;
    pointer-events: none;
  }

  .zoo-login-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: calc(100vh - 120px);
    max-width: 1200px;
    margin: 0 auto;
    padding: 60px 40px;
    gap: 80px;
    align-items: center;
  }

  @media (max-width: 900px) {
    .zoo-login-grid {
      grid-template-columns: 1fr;
      padding: 40px 24px;
      gap: 40px;
    }
    .zoo-login-hero { display: none; }
  }

  /* ---- HERO SIDE ---- */
  .zoo-login-hero {
    position: relative;
    z-index: 2;
  }

  .zoo-login-hero img.hero-logo {
    width: 80px;
    margin-bottom: 32px;
    filter: drop-shadow(0 0 20px rgba(34, 197, 94, 0.4));
  }

  .zoo-login-hero h1 {
    font-size: 3.2rem;
    font-weight: 700;
    color: #f1f5f9;
    line-height: 1.15;
    margin-bottom: 12px;
  }

  .zoo-login-hero h1 span {
    color: #22c55e;
  }

  .zoo-login-hero p {
    font-size: 0.875rem;
    color: #64748b;
    line-height: 1.7;
    max-width: 380px;
    margin-top: 20px;
  }

  .hero-deco {
    display: flex;
    gap: 12px;
    margin-top: 40px;
  }

  .hero-deco-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #22c55e;
    opacity: 0.3;
  }
  .hero-deco-dot:nth-child(2) { opacity: 0.6; }
  .hero-deco-dot:nth-child(3) { opacity: 1; }

  /* ---- CARD SIDE ---- */
  .zoo-login-card {
    position: relative;
    z-index: 2;
    background: rgba(15, 23, 42, 0.8);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 24px;
    padding: 48px 44px;
    backdrop-filter: blur(20px);
    box-shadow: 0 32px 80px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05);
  }

  .card-eyebrow {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: #22c55e;
    margin-bottom: 8px;
  }

  .card-title {
    font-size: 1.9rem;
    color: #f1f5f9;
    font-weight: 700;
    margin-bottom: 32px;
  }

  /* INPUTS */
  .zoo-field {
    margin-bottom: 20px;
  }

  .zoo-field label {
    display: block;
    font-size: 0.8rem;
    font-weight: 500;
    color: #94a3b8;
    margin-bottom: 8px;
    letter-spacing: 0.03em;
  }

  .zoo-field input {
    width: 100%;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    padding: 13px 16px;
    color: #f1f5f9;
    font-size: 0.95rem;
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
    box-sizing: border-box;
  }

  .zoo-field input:focus {
    border-color: #22c55e;
    box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.12);
  }

  .zoo-field input::placeholder { color: #475569; }

  /* SUBMIT BUTTON */
  .zoo-btn-primary {
    width: 100%;
    padding: 14px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border: none;
    border-radius: 12px;
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 4px 20px rgba(34, 197, 94, 0.3);
    margin-top: 8px;
  }

  .zoo-btn-primary:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 28px rgba(34, 197, 94, 0.4);
  }

  /* DIVIDER */
  .zoo-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 24px 0;
    color: #334155;
    font-size: 0.8rem;
  }
  .zoo-divider::before, .zoo-divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(255,255,255,0.07);
  }

  /* SOCIAL BUTTONS */
  .zoo-social-row {
    display: flex;
    gap: 12px;
  }

  .zoo-btn-social {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 11px 12px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    color: #cbd5e1;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
  }

  .zoo-btn-social:hover {
    background: rgba(255,255,255,0.08);
    border-color: rgba(255,255,255,0.2);
  }

  .zoo-btn-social img { width: 18px; height: 18px; }

  /* Google login override */
  .zoo-google-wrapper > div {
    display: flex !important;
    justify-content: center !important;
  }
  .zoo-google-wrapper button {
    border-radius: 12px !important;
    border: 1px solid rgba(255,255,255,0.1) !important;
    background: rgba(255,255,255,0.04) !important;
    color: #cbd5e1 !important;
    font-size: 0.85rem !important;
    box-shadow: none !important;
    padding: 10px 16px !important;
  }

  /* FOOTER LINK */
  .zoo-card-footer {
    text-align: center;
    margin-top: 28px;
    font-size: 0.875rem;
    color: #475569;
  }

  .zoo-card-footer a {
    color: #22c55e;
    text-decoration: none;
    font-weight: 600;
    margin-left: 4px;
  }

  .zoo-card-footer a:hover { text-decoration: underline; }
`;

function LoginForm() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});

  const date = new Date();
  const time = date.toISOString().replace(/[-:T.]/g, '').slice(0, 14);
  const timeWithKey = time + '@pay';
  const saltRounds = 10;
  const clientId = "381801295139-qnj77qb40mfo3fi73q99fc3tq59rq6qg.apps.googleusercontent.com";

  useEffect(() => {
    liff.init({ liffId: `${LIFF_ID}` });
  }, []);

  const handleLogin = () => {
    try { liff.login(); } catch (err) { console.log(err); }
  };

  useEffect(() => {
    const initClient = () => gapi.client.init({ clientId, scope: '' });
    gapi.load("client:auth2", initClient);
  }, []);

  const onSuccess = (res) => {
    Slogin(res.profileObj.email, "google", res.profileObj.googleId.slice(0, 10), res.profileObj.name, res.profileObj.googleId);
  };
  const onFailure = (res) => console.log('failed', res);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) { setIsLoggedIn(true); navigate('/Home'); }
  }, [navigate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs(v => ({ ...v, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formdata = new FormData();
    formdata.append("email", inputs.email);
    formdata.append("password", inputs.password);

    fetch(`${API_ENDPOINT_USER}/e-member/public/api/login`, { method: "POST", body: formdata, redirect: "follow" })
      .then(r => r.json())
      .then(result => {
        if (result.status === true) {
          Swal.fire({ title: 'เข้าสู่ระบบสำเร็จ', text: `ยินดีต้อนรับ, ${result.name}`, icon: 'success', confirmButtonText: 'ต่อไป' })
            .then(() => {
              bcrypt.hash(timeWithKey, saltRounds, (err, hash) => {
                if (!err) genApiKey(result.user_id, hash);
              });
              localStorage.setItem("email", result.email);
              localStorage.setItem("userid", result.user_id);
              localStorage.setItem("name", result.name);
              localStorage.setItem("token", result.access_token);
              navigate('/Home');
            });
        } else {
          Swal.fire({ title: 'เข้าสู่ระบบไม่สำเร็จ', text: 'กรุณาตรวจสอบอีเมลและรหัสผ่านอีกครั้ง', icon: 'error', confirmButtonText: 'ลองใหม่' });
        }
      })
      .catch(error => {
        console.error(error);
        Swal.fire({ title: 'เกิดข้อผิดพลาด', text: 'กรุณาลองใหม่ภายหลัง', icon: 'error', confirmButtonText: 'ตกลง' });
      });
  };

  const Slogin = (email, provider, provider_id, name, token) => {
    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("provider", provider);
    formdata.append("provider_id", provider_id);
    formdata.append("name", name);

    fetch(`${API_ENDPOINT_USER}/e-member/public/api/slogin`, { method: "POST", body: formdata, redirect: "follow" })
      .then(r => r.json())
      .then(result => {
        if (result.status === "true") {
          bcrypt.hash(timeWithKey, saltRounds, (err, hash) => {
            if (!err) genApiKey(result.msg.id, hash);
          });
          localStorage.setItem('email', result.msg.email);
          localStorage.setItem('userid', result.msg.id);
          localStorage.setItem('name', result.msg.name);
          localStorage.setItem('token', token);
          navigate('/Home');
        }
      })
      .catch(console.error);
  };

  const genApiKey = (iduset, auth) => {
    const url = new URL(`${API_ENDPOINT}/api/v1/zoo/public/e-member/genApiKey`);
    url.searchParams.append("model", "web");
    url.searchParams.append("member_id", iduset);
    url.searchParams.append("time", time);
    url.searchParams.append("auth", auth);

    fetch(url, { method: "GET", redirect: "follow" })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(result => {
        localStorage.setItem('apikey', result[0].replace(/^"|"$/g, ''));
        localStorage.setItem('credit', result[1].replace(/^"|"$/g, ''));
      })
      .catch(console.error);
  };

  return (
    <>
      <style>{styles}</style>
      <Navbar />
      <div className="zoo-login-page">
        <div className="zoo-login-grid">

          {/* HERO */}
          <div className="zoo-login-hero">
            <img src={Logo} alt="Zoo Logo" className="hero-logo" />
            <h1>ยินดีต้อนรับสู่<br /><span>Zoo e-Ticket</span></h1>
            <p>
              องค์การสวนสัตว์แห่งประเทศไทย ในพระบรมราชูปถัมภ์<br />
              The Zoological Park Organization under The Royal Patronage of H.M. The King<br />
              เลขที่ 327 ถนนสุโชทัย แขวงดุสิต กรุงเทพมหานคร 10300
            </p>
            <div className="hero-deco">
              <div className="hero-deco-dot"></div>
              <div className="hero-deco-dot"></div>
              <div className="hero-deco-dot"></div>
            </div>
          </div>

          {/* CARD */}
          <div className="zoo-login-card">
            <div className="card-eyebrow">Zoo e-Ticket</div>
            <div className="card-title">เข้าสู่ระบบ</div>

            <form onSubmit={handleSubmit}>
              <div className="zoo-field">
                <label htmlFor="email">อีเมล</label>
                <input type="email" id="email" name="email" placeholder="your@email.com" onChange={handleChange} required />
              </div>

              <div className="zoo-field">
                <label htmlFor="password">รหัสผ่าน</label>
                <input type="password" id="password" name="password" placeholder="••••••••" onChange={handleChange} required />
              </div>

              <button type="submit" className="zoo-btn-primary">เข้าสู่ระบบ</button>
            </form>

            <div className="zoo-divider">หรือเข้าสู่ระบบด้วย</div>

            <div className="zoo-social-row">
              <div className="zoo-google-wrapper" style={{ flex: 1 }}>
                <GoogleLogin
                  clientId={clientId}
                  buttonText="Google"
                  onSuccess={onSuccess}
                  onFailure={onFailure}
                  cookiePolicy={'single_host_origin'}
                  isSignedIn={true}
                />
              </div>
              <button onClick={handleLogin} type="button" className="zoo-btn-social">
                <img src={lineLogo} alt="LINE" />
                LINE
              </button>
            </div>

            <div className="zoo-card-footer">
              ยังไม่มีบัญชี?
              <Link to="/regis">สมัครสมาชิก</Link>
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
}

export default LoginForm;